<template>
  <div class="audiozw">
    <div class="wzname mt20">{{audioinfo.title}}</div>
    <div class="wzlabel flex_start mt10">
      <div class="time flex_start">
        <img src="../../../assets/claim/time.png" alt="" />
        {{
          audioinfo.updated_at || "2020.09.10"
        }}
      </div>
      <div class="biaoqian flex_start">
        <img src="../../../assets/claimdet/detbaqaicon.png" alt="" />{{audioinfo.tag}}
      </div>
      <div class="liulan flex_start">
        <img src="../../../assets/base/kan.png" alt="" />{{audioinfo.view_num}}次浏览
      </div>
    </div>

    <div class="zwcover mt40">
      <audio controlslist="nodownload" controls 
      :src="audioinfo.file_url"></audio>
    </div>

    <div class="lawanswer mt30">
      <div class="jdbt"><i class="el-icon-caret-right jdicon"></i>律师解答</div>
      <div class="lawin flex_start mt20">
        <div class="lawcov">
          <img src="../../../assets/\contmodeldet/law_y_sample.png" alt="" />
        </div>
        <div>张三</div>
      </div>
      <div class="answernr flex_start">
        <div class="huidaicon">
          <img src="../../../assets/claimdet/huidaicon.png" alt="" />
        </div>
        <div class="huidatext" v-html="audioinfo.content"></div>
      </div>
      <!-- <div class="answeryj mt20" v-if="false" >
        <div class="fyyj">法律依据</div>
        <div class="yjlist">
          <div class="yjitem">重大节假日免收小型客车通行费实施方案》第一条</div>
        </div>
      </div> -->
    </div>
    <div class="caozuo">
      <div class="banquan">
        *版权声明：律观网对精选解答模式享有独家版权，未经许可不得以任何形式复制、转载。
      </div>
      <div class="btnquyu center">
        <div class="btn btndz center">
          <img src="../../../assets/claimdet/icon_dz.png" alt="" />
          点赞
        </div>

        <div class="btn btnsc center">
          <img src="../../../assets/claimdet/icon_sc.png" alt="" />
          收藏
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
  props: {
    audioinfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      };
  },
};
</script>

<style lang="scss" scoped>
.audiozw {
  width: 100%;
  padding: 27px 22px;
  .wzname {
    font-size: 30px;
    color: #333333;
  }
  .wzlabel {
    font-size: 12px;
    color: #999999;
    > div {
      margin-right: 30px;
    }
    img {
      margin-right: 5px;
    }
    .time img {
      width: 13px;
      height: 13px;
    }
    .biaoqian img {
      width: 13px;
      height: 13px;
    }

    .liulan img {
      width: 14px;
      height: 10px;
    }
  }

  .zwcover {
    text-align: center;
    audio {
      width: 714px;
      outline: none;
    }
  }
  .lawanswer {
    padding-left: 10px;
    .jdbt {
      font-size: 20px;
      color: #333333;
      padding-left: 20px;
      left: -16px;
      position: relative;
      .jdicon {
        position: absolute;
        top: 4px;
        left: 0;
        color: #0465ea;
      }
    }
    .lawin {
      font-size: 18px;
      color: #333333;
      .lawcov {
        margin-right: 10px;
        img {
          width: 36px;
          height: 37px;
          border-radius: 50%;
        }
      }
    }
    .answernr {
      align-items: flex-start;
      margin-top: 15px;
      .huidaicon {
        margin-right: 13px;
        img {
          width: 21px;
          height: 23px;
        }
      }
      .huidatext {
        width: 775px;
        font-size: 14px;
        color: #333333;
        line-height: 26px;
      }
    }
    .answeryj {
      .fyyj {
        font-size: 18px;
        color: #333333;
      }
      .yjlist {
        font-size: 14px;
        color: #333333;
        padding-top: 5px;
        .yjitem {
          margin-top: 10px;
        }
      }
    }
  }
  .caozuo {
    margin-top: 20px;
    padding-top: 30px;
    border-top: 1px #9999 dashed;
    .banquan {
      font-size: 14px;
      color: #cccccc;
    }
    .btnquyu {
      margin-top: 30px;
      .btn {
        cursor: pointer;
        width: 90px;
        height: 27px;
        font-size: 16px;
        border-radius: 14px;
      }
      .btndz {
        border: 1px solid #ea6504;
        color: #ea6504;
        margin-right: 40px;
      }
      .btnsc {
        border: 1px solid #999999;
        color: #999999;
      }
    }
  }
}
</style>